module.exports = __webpack_public_path__ + "img/visaMaster.dc8190f9.svg";